import React from "react";
import { withTranslation, type WithTranslation } from "react-i18next";
import Error from "../../../assets/images/error.png";
import { Modal } from "../ui";

interface SuperPopinProps extends WithTranslation {
  shown: boolean;
  children: React.ReactNode;
  closePopin: () => void;
  additionalClasses?: string[];
  inputProps?: Record<string, unknown>;
}

function SuperPopin({ t, shown, children, closePopin, additionalClasses }: SuperPopinProps) {
  const classes =
    additionalClasses && additionalClasses.length ? additionalClasses.join(" ") : undefined;

  return (
    <Modal isOpen={shown} onClose={closePopin} className={classes} size="lg">
      <div className="SuperPopin-close">
        <button
          type="button"
          className="SuperPopin-closeButton"
          style={{ padding: 0, border: 0, background: "none", cursor: "pointer" }}
          onClick={closePopin}
          aria-label={t("common.label_close")}
        >
          <img src={Error} alt="" />
        </button>
      </div>
      {children}
    </Modal>
  );
}

export default withTranslation()(SuperPopin);
